import classNames from 'classnames';
import React from 'react';
import { createUseStyles } from 'react-jss';
import Colours from '../tokens/colours';
const useStyles = createUseStyles({
    root: {
        borderRadius: 4,
        backgroundColor: Colours.white,
    },
});
export default function Panel({ children, className }) {
    const styles = useStyles();
    return (React.createElement("div", { className: classNames(styles.root, className) }, children));
}
//# sourceMappingURL=Panel.js.map